import { SupplierActivity } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierActivity.Configuration
});

export default config;
